const dbShopBundle = require("../../../../shared/data/dbShopBundle.json");
const {
	loadCartFromStorage,
	getItemsForSubType,
	modifyCart,
	addItemsToCart,
} = require("./CartUtil");
const {
	cleanSubscriptionName,
	isBadNameInSubscriptions,
} = require("../../../../shared/StoreUtil");
const ElevPrices = require("./ElevPrices");

const priceInfo = {
	monthly: {
		unit: "month",
		shortUnit: "mo",
	},
	yearly: {
		unit: "year",
		shortUnit: "yr",
	},
};

const state = {
	hasAttemptedSubmit: false,
	cartSubs: [],
	newSubs: [],
};
const MAX_SUBS = 6;

function addNewSub(subType) {
	const sub = {
		subType,
		name: "",
		errors: [],
	};
	state.newSubs.push(sub);
	return sub;
}

function addToCartFunc() {
	if (state.newSubs.length === 0) {
		window.location.href = "/checkout/cart";
		return;
	}
	state.hasAttemptedSubmit = true;
	if (validateSubs(state)) {
		modifyCart(c => {
			const addSubToTempCart = sub => {
				const items = getItemsForSubscription(sub);
				addItemsToCart(items, c);
			};

			state.newSubs.forEach(sub => addSubToTempCart(sub));
		});

		state.movedSubs = [];
		while (state.newSubs.length) {
			// Remove old sub from new subscriptions and recreate asgenerate cart subscription
			const subToMove = state.newSubs[0];
			state.movedSubs.push(Object.assign({}, subToMove));
			delete subToMove.el;
			state.newSubs.shift();
			subToMove.fromCart = true;
			state.cartSubs.push(subToMove);
		}
		return true;
	} else {
		return false;
	}
}

function canAddSubRow() {
	return getSubCount() < MAX_SUBS;
}

function getCountOfSubType(subType) {
	let count = 0;
	for (let i = 0; i < state.cartSubs.length; i++) {
		if (state.cartSubs[i].subType === subType) count++;
	}
	for (let i = 0; i < state.newSubs.length; i++) {
		if (state.newSubs[i].subType === subType) count++;
	}
	return count;
}

function getItemsForSub(sub) {
	return getItemsForSubType(sub.subType, sub.name, sub.selectedBundles);
}

function getItemsForSubscription(sub) {
	const items = [];

	if (sub.subType === "bundle") {
		for (let b = 0; b < sub.selectedBundles.length; b++) {
			const bundleID = "bundle-grade-" + sub.selectedBundles[b];
			const skus = dbShopBundle[bundleID].skus;
			for (let skuIndex = 0; skuIndex < skus.length; skuIndex++) {
				const sku = skus[skuIndex];
				const item = {
					sku,
					quantity: 1,
					options: {
						bundleID: bundleID,
					},
				};
				if (sku !== "beast-yearly") {
					items.push(item);
				} else {
					item.options.displayName = sub.name;
					items.push(item);
				}
			}
		}
	} else {
		items.push({
			sku: "beast-" + sub.subType,
			quantity: 1,
			options: {
				displayName: sub.name,
			},
		});
	}

	return items;
}

function getRowPrice(subType, config = {}) {
	const currentSubs = state.cartSubs.concat(state.newSubs);
	const addedSampleSub = {subType, name: "name", selectedBundles: [3]};
	const fullSubs = currentSubs.concat([addedSampleSub]);
	const fullSubsPrices = getSubsWithPrices(fullSubs);

	return getSubDisplayPrice(fullSubsPrices[currentSubs.length], config);
}

function getSubDisplayPrice(subObj, config = {}) {
	const defaults = {
		unit: "unit",
		forceDecimal: true,
		includeDollarSign: false,
	};

	config = Object.assign({}, defaults, config);
	if (!subObj.actualTotal) {
		const currentSubs = state.cartSubs.concat(state.newSubs);
		getSubsWithPrices(currentSubs);
	}

	const actualPrice = subObj.actualPrice;
	const useDecimal =
		config.forceDecimal || Math.round(actualPrice) !== actualPrice;
	const returnPlaces = useDecimal ? 2 : 0;
	const prepend = config.includeDollarSign ? "$" : "";
	const unitString =
		subObj.subType === "bundle"
			? ""
			: `/${priceInfo[subObj.subType][config.unit]}`;

	return `${prepend}${actualPrice.toFixed(returnPlaces)}${unitString}`;
}

function getSubCount() {
	return state.newSubs.length + state.cartSubs.length;
}

// Given an array of sub objects, like in state.cartSubs or state.newSubs,
// mutates the array adding actualPrice and basePrice fields to each and
// returns it.
function getSubsWithPrices(subs) {
	// All items for all subscriptions.
	const items = [];
	// Some subscriptions, like bundles, expand into multiple items. This array
	// will have as many elements as subs, and will give the items index where
	// the items for that subscription starts. It will also get one more
	// element at the end equal to items.length to make using it easier.
	const itemStartIndices = [];

	subs.forEach(s => {
		itemStartIndices.push(items.length);
		const sItems = getItemsForSub(s);
		sItems.forEach(item => items.push(item));
	});
	itemStartIndices.push(items.length);

	const itemsWithPrices = ElevPrices.calculateItemPrices(items);
	const itemsWithBasePrices = ElevPrices.calculateItemPrices(items, {
		skipDiscounts: true,
	});

	return subs.map((s, i) => {
		const start = itemStartIndices[i];
		const end = itemStartIndices[i + 1];
		const actualItems = itemsWithPrices.slice(start, end);
		const actualPrice = actualItems.reduce((acc, item) => acc + item.price, 0);
		s.actualPrice = ElevPrices.finishPrice(actualPrice);
		const baseItems = itemsWithBasePrices.slice(start, end);
		const basePrice = baseItems.reduce((acc, item) => acc + item.price, 0);
		s.basePrice = ElevPrices.finishPrice(basePrice);
		return s;
	});
}

function loadSubsFromCart() {
	state.cartSubs.length = 0;

	const cart = loadCartFromStorage();

	if (cart) {
		const items = cart.items;
		const bundleSubsByName = {};

		for (let i = 0; i < items.length; i++) {
			const item = items[i];
			const name = item.options.displayName;
			if (item.sku === "beast-monthly") {
				state.cartSubs.push({
					subType: "monthly",
					name,
					fromCart: true,
					errors: [],
				});
			} else if (item.sku === "beast-yearly") {
				const bundleID = item.options.bundleID;
				if (bundleID) {
					const bundleGrade = parseInt(bundleID.substring(13));
					const existingBundleSub = bundleSubsByName[name];
					if (existingBundleSub) {
						existingBundleSub.selectedBundles.push(bundleGrade);
					} else {
						// create sub
						const sub = {
							subType: "bundle",
							name,
							fromCart: true,
							selectedBundles: [bundleGrade],
							errors: [],
						};
						state.cartSubs.push(sub);
						bundleSubsByName[name] = sub;
					}
				} else {
					state.cartSubs.push({
						subType: "yearly",
						name,
						fromCart: true,
						errors: [],
					});
				}
			}
		}
	}
}

function validateSubs(stateObj) {
	if (!stateObj.hasAttemptedSubmit) return;
	let allFieldsValid = true;

	const subs = stateObj.cartSubs.concat(stateObj.newSubs);
	const cleanedNames = subs.map(s => cleanSubscriptionName(s.name || ""));

	for (const sub of subs) {
		sub.errors = [];

		if (!sub.name) sub.errors.push("E_NO_NAME");
		const cleanedName = cleanSubscriptionName(sub.name);
		if (!cleanedName) sub.errors.push("E_DISALLOWED_CHARACTERS");

		const error = isBadNameInSubscriptions(cleanedNames, cleanedName, true);
		if (error) sub.errors.push(error);

		if (
			sub.subType === "bundle" &&
			!(sub.selectedBundles && sub.selectedBundles.length > 0)
		)
			sub.errors.push("E_NO_GRADE");
		if (sub.errors.length) allFieldsValid = false;
	}
	return allFieldsValid;
}

module.exports = {
	state,
	MAX_SUBS,
	addNewSub,
	addToCartFunc,
	canAddSubRow,
	getCountOfSubType,
	getItemsForSub,
	getRowPrice,
	getSubCount,
	getSubDisplayPrice,
	getSubsWithPrices,
	loadSubsFromCart,
	validateSubs,
};
